'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SIZE_LIMIT_EXCEEDED = exports.SIZE_LIMIT_EXCEEDED = 'SIZE_LIMIT_EXCEEDED';

var BLACKLISTED_EXTENSION = exports.BLACKLISTED_EXTENSION = 'BLACKLISTED_EXTENSION';

var UPLOAD_ERROR = exports.UPLOAD_ERROR = 'UPLOAD_ERROR';


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/constants/attachmentErrors.js
// module id = 157
// module chunks = 2 3